import { render, staticRenderFns } from "./CloudgroupList.vue?vue&type=template&id=5e4541b4"
import script from "./CloudgroupList.vue?vue&type=script&lang=js"
export * from "./CloudgroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports